import { api } from '@/api';

export interface ChatDocumentUploadNode {
  documentName: string;
  documentSizeMb: number;
  documentFormat: string;
}

export interface PostChatDocumentBulkCreateRequest {
  chatId: string;
  documents: ChatDocumentUploadNode[];
}

export interface ChatBulkCreatedDocument {
  fletchDocumentId: string;
  documentName: string;
}

export interface PostChatDocumentBulkCreateResponse {
  documents: ChatBulkCreatedDocument[];
}

const chatDocumentBulkCreateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postChatDocumentBulkCreate: builder.mutation<PostChatDocumentBulkCreateResponse, PostChatDocumentBulkCreateRequest>(
      {
        query: (body) => ({
          url: '/chat/document/bulk-create',
          method: 'POST',
          body,
        }),
      },
    ),
  }),
});

export const { usePostChatDocumentBulkCreateMutation } = chatDocumentBulkCreateApi;
